import { useBreakoutUser } from 'hooks/profile'
import { useContentLibraryAccess } from 'hooks/contentLibraryAccess'
import { useRootStore } from 'hooks/rootStore'
import { observer } from 'mobx-react-lite'
import type { ReactNode } from 'react'
import { useEffect } from 'react'

// Route gate for the Content Library pages (Slide Decks, Global Authors, Global
// Assets). Access = admin && (contentLibraryEnabled || super admin) — see
// useContentLibraryAccess.
//
// Definite non-admins are redirected home. An admin who fails the flag /
// super-admin check just gets nothing rendered: the super-admin doc loads
// asynchronously, so we don't hard-redirect and risk bouncing a super admin
// mid-load (matches SuperAdminRoleGuard).
export const ContentLibraryGuard = observer(function ContentLibraryGuard({
  children,
}: {
  children: ReactNode
}) {
  const { navigateTo } = useRootStore()
  const user = useBreakoutUser()
  const allowed = useContentLibraryAccess()

  useEffect(() => {
    if (user.role && !user.isAdmin) navigateTo('home')
  }, [navigateTo, user.role, user.isAdmin])

  if (!allowed) return null

  return children
})
